import { render, staticRenderFns } from "./message.vue?vue&type=template&id=ffe7f674"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"
import style0 from "./message.vue?vue&type=style&index=0&id=ffe7f674&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports